import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import './style.css';
import {ApplicationState} from "../../../store";
import {CamerasState} from "../../../store/cameras/types";
import { AlertState } from '../../../store/alerts/types';
import { RouterState } from 'connected-react-router';
import { Routes } from '../../../types';
import { getCameraFromList, getStreamFromCamera } from '../../../utils';
import { APIState } from '../../../store/API/types';


interface Props {
    speed: string,
    pane: number,
    lost: string,
    status: string,
    forwardRef: React.RefObject<HTMLDivElement>
}

interface PlayStatusProps {
    speedShort: string,
    lost: string,
    codec: string,
    width: number,
    height: number,
    label:string
}


const PlayStatusComponent: React.FC<PlayStatusProps> = ({speedShort, codec, lost, label, width, height}) => {
    return (
        <div className='live-status'>
            <div>Resolution: {width}x{height} </div>
            <div>Stream: {label}</div>
            <div>Bandwidth: {speedShort}</div>
        </div>
    )
};


const LiveStatusComponent: React.FC<Props> = ({pane, speed, lost, status, forwardRef}) => {
    const {currentStreams} = useSelector<ApplicationState, CamerasState>(state => state.cameras);

    const {cameras} = useSelector<ApplicationState, APIState>(state => state.API);
    const {selectedEvent} = useSelector<ApplicationState, AlertState>(state => state.alerts);
    const { location } = useSelector<ApplicationState, RouterState>(state => state.router);
    const isAlerts = location.pathname === Routes.alerts;
    let stream = null;
    if (isAlerts && selectedEvent !== null) {
        stream = getStreamFromCamera(cameras, selectedEvent.where_id, forwardRef).stream;
    }

    const {codec = null, label = null, height = null, width = null} = isAlerts ? stream ? stream : {} : (typeof(currentStreams[pane]) != 'undefined' || currentStreams[pane] != null) && currentStreams[pane];
    const speedSplit = speed.split(/[^0-9.]/)[0],
        secondSpeedSplit = speed.split(speedSplit)[1];
    //@ts-ignore
    const speedShort = `${parseFloat(speedSplit).toFixed(0) * 8}${secondSpeedSplit && secondSpeedSplit.slice(0, secondSpeedSplit.length - 3).replace('B', 'b')}`;

    let videoStatus: string;

    switch (status) {
        case 'play': videoStatus = 'Playing...'; break;
        case 'init': videoStatus = 'Initializing...'; break;
        case 'stop': videoStatus = 'Video is not available...'; break;
        case 'froze': videoStatus = 'Video frozen...'; break;
        default: videoStatus = status
    };

    if (status === 'play') return <PlayStatusComponent speedShort={speedShort}
                                                       codec={codec}
                                                       lost={lost}
                                                       label={label}
                                                       width={width}
                                                       height={height}
    />;

    return (
        <div className='live-status'>
            { videoStatus }
        </div>
    )
};


export default LiveStatusComponent;